
const Hero = () => {
  return (
    <section className='max-w-screen-xl mx-auto bg-secondary text-white p-10 pb-0 more'>
      <div className=''>
        <h1 className=' text-3xl md:text-4xl font-pirate text-primary'>
          Welcome to the Camp at Triangles End
        </h1>
        <p className=' font-medium text-primary font-pirate'>
          The Heart of Adventure and Camaraderie
        </p>
        <p className=' font-sans text-primary'>
          Step into the Camp, the vibrant center of life at Triangles End, where
          stories are shared, plans are hatched, and feasts are celebrated under
          the open sky. This is where the crew of Triangles End lives, works,
          and comes together—an immersive hub of action and camaraderie that
          sets the stage for every great adventure.
        </p>
      </div>
    </section>
  )
}

export default Hero
